import {Text, View} from '@react-pdf/renderer';
import React from 'react';
import {styles} from '../styles';

import sleipnerBackground from 'assets/pdf/sleipner-pdf-bg.png';
import {
	HighlightBox,
	MultiLineText,
	PageWithHeaderAndFooter,
	Row,
	RowItem,
	ValueTitle,
	TableRowTwoCol as TableRow,
} from '../documentComponents';
import {formatCurrency, baseFormatClean} from 'components/ModelDetailsTable';

export const MaintenancePage = ({
	customer,
	showellUser,
	calculatedValues,
	recommendedSleipner,
}) => {
	return (
		<PageWithHeaderAndFooter
			headerBackgroundImageUrl={sleipnerBackground}
			footerBackgroundImageUrl={sleipnerBackground}
			customer={customer}
			pageTitle="Maintenance Benefits"
			showellUser={showellUser}
		>
			<View style={styles.layout.containerHorizontal}>
				<ValueTitle>MAINTENANCE COST REDUCTIONS</ValueTitle>
				<MultiLineText styleProps={{fontSize: 10}}>
					During the lifetime of an excavator, the maintenance of the undercarriage
					represents the most critical, expensive and time-consuming maintenance
					operation. With the Sleipner dollies, the undercarriage lifetime is doubled and
					in some cases even tripled.
				</MultiLineText>

				<Row styleProps={{marginTop: 10}}>
					<RowItem styleProps={{paddingRight: 5}}>
						<HighlightBox
							styleProps={{padding: 15, paddingTop: 10, paddingBottom: 15, height: 100}}
						>
							<Text style={{fontSize: 28, fontWeight: 600}}>50%</Text>
							<MultiLineText styleProps={{textAlign: 'left'}}>
								Adding the Sleipner dollies to your operations reduces annual
								undercarriage maintenance costs by at least 50%
							</MultiLineText>
						</HighlightBox>
					</RowItem>

					<RowItem styleProps={{paddingLeft: 5}}>
						<HighlightBox
							styleProps={{padding: 15, paddingTop: 10, paddingBottom: 15, height: 100}}
						>
							<Text style={{fontSize: 28, fontWeight: 600}}>
								{calculatedValues['LCC cost reduction (%)'] + '%'}
							</Text>
							<MultiLineText styleProps={{textAlign: 'left'}}>
								This corresponds to a total reduction of{' '}
								{calculatedValues['LCC cost reduction (%)'] + '%'} in life cycle costs
								(LCC)
							</MultiLineText>
						</HighlightBox>
					</RowItem>
				</Row>

				<TableRow title="Hourly life cycle cost reduction ($/h)" marginTop={10}>
					{formatCurrency(calculatedValues['LCC cost reduction ($/h)']) + '/h'}
				</TableRow>
				<TableRow title="LCC reduction percentage">
					{calculatedValues['LCC cost reduction (%)'] + '%'}
				</TableRow>
				<TableRow title="Undercarriage-related labour hours saved during lifetime">
					{calculatedValues[
						'Undercarriage related labour hours saving during lifetime (h)'
					] + ' h'}
				</TableRow>
				<TableRow title="Undercarriage-related labour costs saved during lifetime">
					{formatCurrency(
						calculatedValues[
							'Undercarriage related labour hours saving during lifetime ($)'
						],
					)}
				</TableRow>
				<TableRow title="Lifetime savings in undercarriage rebuilds">
					{formatCurrency(
						calculatedValues['Lifetime undercarriage rebuild part savings ($)'],
					)}
				</TableRow>
				<TableRow title="Annual savings in undercarriage rebuilds" noBorder>
					{formatCurrency(
						calculatedValues['Annual undercarriage rebuild part savings ($)'],
					)}
				</TableRow>

				<Row styleProps={{marginTop: 15}}>
					<RowItem>
						<ValueTitle>Example of production increase</ValueTitle>
						<MultiLineText styleProps={{fontSize: 10, marginBottom: 5}}>
							Depending on the environment and ground conditions, our solution offers real
							value. The more time you put into digging instead of tramming or spending
							time on maintenance, the more productive your operations will be. Our case
							calculations are based on your fleet information and demonstrate how much
							you can improve your productivity in terms of actual values. Take a look and
							be amazed how at much more you could gain!
						</MultiLineText>
					</RowItem>
				</Row>
				<TableRow title="Annual increase in production">
					{baseFormatClean(calculatedValues['Annual increase in production (tonnes)']) +
						' tonnes'}
				</TableRow>
				<TableRow title="Annual production increase">
					{formatCurrency(calculatedValues['Production increase ($)'])}
				</TableRow>

				<ValueTitle style={{marginTop: 15}}>SUMMARY OF KEY BENEFITS</ValueTitle>
				<HighlightBox>
					<TableRow title="Annual production increase" noBorder>
						{formatCurrency(calculatedValues['Production increase ($)'])}
					</TableRow>
					<TableRow title="Lifetime savings in undercarriage rebuilds" noBorder>
						{formatCurrency(
							calculatedValues['Lifetime undercarriage rebuild part savings ($)'],
						)}
					</TableRow>
					<TableRow title="Lifetime reduction in CO2 emissions" noBorder>
						{`${baseFormatClean(
							calculatedValues['CO2 reduction with Sleipner in lifetime (tonnes)'],
						)} tonnes`}
					</TableRow>
					<TableRow title="Payback time" noBorder>
						{`${baseFormatClean(
							calculatedValues['Investment payback time (month)'],
						)} months`}
					</TableRow>
				</HighlightBox>
				<Text style={{fontSize: 9, marginTop: 8}}>
					* Figures used for calculations are based on industry averages.
				</Text>
			</View>
		</PageWithHeaderAndFooter>
	);
};
